export function getTotalFromHeaderRange(res){
    const headerRange = res.headers.get("Content-Range");
    if (headerRange) {
        const arr = headerRange.split(/[\/-]/);
        if (arr) {
            const [start, end, total] = arr.map(Number);
            return total;
        }        
    }    
}